import React from 'react';
import styled from '@emotion/styled';

import { ComponentStyle, ProductComponentProps } from '../../types/types';

import VerticalSplit from '../shared/containers/VerticalSplit';
import { HeaderBackgroundPattern } from './HeaderBackgroundPattern';
import { HeaderTitle } from './HeaderTitle';
import { HeaderImage } from './HeaderImage';

const HeaderContainer = styled.div({
  color: 'var(--color-white)',
  justifyContent: 'center',
  overflow: 'visible',
  position: 'relative',
  // z-index is 1 here to ensure the pattern overlaps the component below
  zIndex: 1,

  '&.A': {
    backgroundColor: 'var(--color-dark)',
  },

  '&.B': {
    backgroundColor: 'var(--color-secondary-2)',
  },

  // same background colour as variant A but it uses different font style
  '&.C': {
    backgroundColor: 'var(--color-dark)',
  },
});

export const Header: React.FC<ProductComponentProps> = props => {
  const { title, description, image } = props.productComponent;
  const style = props.productComponent.style || ComponentStyle.A;
  const componentIdx = props.index ?? 0;
  return (
    <HeaderContainer id={`mp-header-${componentIdx}`} className={style} data-testid='mp-header'>
      <HeaderBackgroundPattern style={style} />
      {image ? (
        <VerticalSplit>
          <HeaderTitle style={style} title={title} strapline={description} />
          <HeaderImage image={image} />
        </VerticalSplit>
      ) : (
        <HeaderTitle style={style} title={title} strapline={description} />
      )}
    </HeaderContainer>
  );
};
